module.exports = __webpack_public_path__ + "static/media/bg_traveler_reading.dc8c96eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_traveler_reading.jpg
// module id = 287
// module chunks = 0